const boolValue = (val: string | undefined) => val === 'true';

export const STATIC_FLAGS = {
  DEV_MASQUERADE_LOGIN: {
    description:
      'Enables masquerade login shortcut on the login page (dev only)',
    defaultValue: boolValue(process.env.DEV_MASQUERADE_LOGIN),
  },
  ENABLE_GOOGLE_SIGN_IN: {
    description: 'Enables google sign in',
    defaultValue: boolValue(process.env.ENABLE_GOOGLE_SIGN_IN),
  },
  SBL_4724_PENDING_REQUIREMENTS: {
    description:
      'Used to enable new Requirements tab in pending items. See /roster',
  },
  SBL_3435_SHOW_BULK_ENTRY_MB: {
    description: 'Used to enable bulk entry of MBs on the /roster page',
    defaultValue: boolValue(process.env.SBL_3435_SHOW_BULK_ENTRY_MB),
  },
  MAINTENANCE_MESSAGE: {
    description: 'Maintenance message on the login page',
    type: 'string' as const,
  },
  MAINTENANCE_END_DATE: {
    description: 'Maintenance message on the login page',
    type: 'string' as const,
  },
  SHOW_YOUTH_ADV_REQUIREMENTS: {
    description:
      'Allows the user to go to the rank/MB/adventure/etc. details and complete requirements',
  },
  SBL_5198_CUB_PROFILE_VIEWMORE: {
    description:
      'Allows CUB program users to see advancements and requirements. This overrides SHOW_YOUTH_ADV_REQUIREMENTS',
    defaultValue: boolValue(process.env.SBL_5198_CUB_PROFILE_VIEWMORE),
  },
  SBL_4848_PENDING_LEADERSHIP_POSITIONS: {
    description: 'Enables Leadership Positions on the Pending Items tabs',
    defaultValue: boolValue(process.env.SBL_4848_PENDING_LEADERSHIP_POSITIONS),
  },
  SBL_4463_ADVANCEMENTS_TAB: {
    description: 'This will show the Advancements Tab on the /roster page',
    defaultValue: boolValue(process.env.SBL_4463_ADVANCEMENTS_TAB),
  },
  SBL_4463_HIDE_HISTORY_TAB: {
    description: 'This will hide the History Tab on the /roster page',
    defaultValue: boolValue(process.env.SBL_4463_HIDE_HISTORY_TAB),
  },
  SBL_4463_HIDE_PENDING_ITEMS_TAB: {
    description: 'This will hide the Pending Items Tab on the /roster page',
    defaultValue: boolValue(process.env.SBL_4463_HIDE_PENDING_ITEMS_TAB),
  },
  SBL_4463_SHOW_TO_APPROVE_AWARDS: {
    description:
      'This will show the awards section in To Approve tab in Advancement tab.',
    defaultValue: boolValue(process.env.SBL_4463_SHOW_TO_APPROVE_AWARDS),
  },
  SBL_4463_SHOW_TO_APPROVE_ACTIVITIES: {
    description:
      'This will show the activities section in To Approve tab in Advancement tab.',
    defaultValue: boolValue(process.env.SBL_4463_SHOW_TO_APPROVE_ACTIVITIES),
  },
  SBL_5505_CHECK_ADV_PO: {
    description:
      'This will enable the checking of POID of advancement before updating in the Youth Profile',
    defaultValue: boolValue(process.env.SBL_5505_CHECK_ADV_PO),
  },
  SBL_4688_ADD_INDIVIDUAL: {
    description: 'Add Den Chief button on the Roster table head',
  },
  SBL_5140_DENCHIEF: {
    description:
      'This will show sections related to Den Chief position in roster and youth profile',
  },
  SBL_5026_DENCHIEF_CALENDAR: {
    description:
      'Enables logic in calendar to get Den chief related data from unknown units',
  },
  SBL_5499_COMPLETE_PROFILE_API: {
    description:
      'Migrate complete profile endpoint to RTK and avoid calling it multiple times',
  },
  SBL_5489_SHOW_FILTERED_OUT: {
    description:
      'Rather than filtering out, show but disable unapprovable pending items',
    defaultValue: boolValue(process.env.SBL_5489_SHOW_FILTERED_OUT),
  },
  SBL_5123_YOUTH_RELATIONSHIPS_DELETING: {
    description: 'Enable deleting Youth Relationships',
    defaultValue: boolValue(process.env.SBL_5123_YOUTH_RELATIONSHIPS_DELETING),
  },
  SBL_5371_YOUTH_INVITATIONS_READING: {
    description: 'Enable reading Parent/Guardian Invitations',
    defaultValue: boolValue(process.env.SBL_5371_YOUTH_INVITATIONS_READING),
  },
  SBL_5371_YOUTH_INVITATIONS_CREATING: {
    description: 'Enable creating Parent/Guardian Invitations',
    defaultValue: boolValue(process.env.SBL_5371_YOUTH_INVITATIONS_CREATING),
  },
  SBL_5371_YOUTH_INVITATIONS_DELETING: {
    description: 'Enable deleting Parent/Guardian Invitations',
    defaultValue: boolValue(process.env.SBL_5371_YOUTH_INVITATIONS_DELETING),
  },
  SBL_5110_FORCE_ENABLE_OPT_OUT: {
    description: 'Force enable opt out',
    defaultValue: boolValue(process.env.SBL_5110_FORCE_ENABLE_OPT_OUT),
  },
  SBL_5580_AOL_POSITIONS: {
    description: 'Enable troop positions for AOL members',
    defaultValue: boolValue(process.env.SBL_5580_AOL_POSITIONS),
  },
  /** This is only for youth */
  SHOW_PAYMENT_LOGS: {
    description: 'Allow to view payment logs for the youth',
    defaultValue: boolValue(process.env.SHOW_PAYMENT_LOGS),
  },
  SHOW_UNIT_PAYMENT_LOGS: {
    description: 'Allow to view unit payment logs SBL-2827',
    defaultValue: boolValue(process.env.SHOW_UNIT_PAYMENT_LOGS),
  },
  SHOW_DOWNLOAD_CSV_PAYMENT_LOGS: {
    description: 'Allow to download CSV report in payment logs',
    defaultValue: boolValue(process.env.SHOW_DOWNLOAD_CSV_PAYMENT_LOGS),
  },
  SBL_5606_WHITELIST_UNIT_PAYMENT_LOGS: {
    description: 'Enables payment logs for certain units',
    defaultValue: process.env.SBL_5606_WHITELIST_UNIT_PAYMENT_LOGS,
    type: 'string' as const,
  },
  SBL_5450_DROP_OUT: {
    description: 'Enables the dropped out feature',
    defaultValue: boolValue(process.env.SBL_5450_DROP_OUT),
  },
  SBL_4005_SHOW_RANK_QUICK_ENTRY: {
    description: 'Shows the bulk entry items in the roster dropdown',
    defaultValue: boolValue(process.env.SBL_4005_SHOW_RANK_QUICK_ENTRY),
  },
  SBL_5746_ENABLE_ADV_BETA_UNITS: {
    description:
      'Enables advancement related pages like bulk entry or req. details for beta units. It overrides SHOW_YOUTH_ADV_REQUIREMENTS',
    defaultValue: process.env.SBL_5746_ENABLE_ADV_BETA_UNITS,
    type: 'string' as const,
  },
  SBL_5483_GROUPBY_ORDER_STATUS: {
    description: 'Adds the option to group roster by order status',
    defaultValue: boolValue(process.env.SBL_5483_GROUPBY_ORDER_STATUS),
  },
  SBL_3440_CUSTOM_REPORTS: {
    description: 'Enables custom reports tab',
    defaultValue: boolValue(process.env.SBL_3440_CUSTOM_REPORTS),
  },
  SBL_4672_RECURRENCE: {
    description: 'Enable span of days in recurrence events',
    defaultValue: boolValue(process.env.SBL_4672_RECURRENCE),
  },
  SBL_5109_AVOID_REFETCH_ROSTER: {
    description: 'Avoids roster refetching',
    defaultValue: boolValue(process.env.SBL_5109_AVOID_REFETCH_ROSTER),
  },
  SBL_4143_SHOW_MESSAGING: {
    description: 'Shows the messaging functionality',
    defaultValue: boolValue(process.env.SBL_4143_SHOW_MESSAGING),
  },
  SBL_3429_SHOW_BALANCE_MESSAGING: {
    description: 'Shows the payment log messaging functionality',
    defaultValue: boolValue(process.env.SBL_3429_SHOW_BALANCE_MESSAGING),
  },
  SBL_4409_SHOW_MBC_MESSAGING: {
    description: 'Shows the mbc messaging functionality',
    defaultValue: boolValue(process.env.SBL_4409_SHOW_MBC_MESSAGING),
  },
  SBL_4519_SERIES_FROM_EVENT: {
    description:
      'Enables item in dropdown of calendar to create event from series',
    defaultValue: boolValue(process.env.SBL_4519_SERIES_FROM_EVENT),
  },
  SBL_4674_STRIPE_UNIT_PAYMENTS: {
    description: 'Enables stripe payments for units',
    defaultValue: boolValue(process.env.SBL_4674_STRIPE_UNIT_PAYMENTS),
  },
  SBL_2908_CALENDAR_CSV_DOWNLOAD: {
    description: 'Enable CSV download on Calendar',
    defaultValue: boolValue(process.env.SBL_2908_CALENDAR_CSV_DOWNLOAD),
  },
  PREVENT_STORE_SB_PREFERENCE: {
    description: 'Prevents saving default unit in local storage',
    defaultValue: boolValue(process.env.PREVENT_STORE_SB_PREFERENCE),
  },
  SBL_4366_BULK_ENTRY_AWARDS: {
    description: 'Bulk entry for awards',
    defaultValue: boolValue(process.env.SBL_4366_BULK_ENTRY_AWARDS),
  },
  SBL_6170_SHOW_RECORD_ADVANCEMENT: {
    description:
      'Show "Record Advancement" from "Record Progress" Menu in roster',
    defaultValue: boolValue(process.env.SBL_6170_SHOW_RECORD_ADVANCEMENT),
  },
  SBL_1721_MBC_BADGES_EDIT: {
    description: 'Show MBC badges on profile',
    defaultValue: boolValue(process.env.SBL_1721_MBC_BADGES_EDIT),
  },
  SBL_4905_SEQUENTIAL_VERSION_GATEKEEPER: {
    description: 'Sequential version gatekeeper popup',
    defaultValue: boolValue(process.env.SBL_4905_SEQUENTIAL_VERSION_GATEKEEPER),
  },
  SBL_6123_ENABLE_RECALCULATE: {
    description: 'Enables recalculate on Rank when approving adventures',
    defaultValue: boolValue(process.env.SBL_6123_ENABLE_RECALCULATE),
  },
  SBL_6123_SHOW_LINKED_REQ_NOTE: {
    description:
      'Show notes on every linked requirement that cannot be approve.',
    defaultValue: boolValue(process.env.SBL_6123_SHOW_LINKED_REQ_NOTE),
  },
  SBL_6323_SHOW_NEW_RANK_MB_REQ: {
    description: 'Shows the new section of rank requirement 3 for Life/Star',
    defaultValue: boolValue(process.env.SBL_6323_SHOW_NEW_RANK_MB_REQ),
  },
  SBL_6323_SHOW_NEW_RANK_MB_REQ_V2: {
    description:
      'Shows the 2nd variant section of rank requirement 3 for Life/Star',
    defaultValue: boolValue(process.env.SBL_6323_SHOW_NEW_RANK_MB_REQ_V2),
  },
  SBL_6416_SHOW_REGISTERED_POSITIONS: {
    description:
      'Shows registered positions of the permission manager in the assign tab',
    defaultValue: boolValue(process.env.SBL_6416_SHOW_REGISTERED_POSITIONS),
  },
  SBL_6156_ENABLE_MBC_YOUTH_PROF_ASSIGN: {
    description: 'Enable assigment of MBC in youth profile',
    defaultValue: boolValue(process.env.SBL_6156_ENABLE_MBC_YOUTH_PROF_ASSIGN),
  },
  SBL_4357_BULK_ASSIGN_MBC: {
    description: 'Shows screen to bulk upload MB badges',
    defaultValue: boolValue(process.env.SBL_4357_BULK_ASSIGN_MBC),
  },
  SBL_5804_SHOW_MBC_SEARCH_PAGE: {
    description: 'Shows MBC search page.',
    defaultValue: boolValue(process.env.SBL_5804_SHOW_MBC_SEARCH_PAGE),
  },
  SBL_4405_SHOW_MBC_DASHBOARD: {
    description: 'Shows MBC dashboard page.',
    defaultValue: boolValue(process.env.SBL_4405_SHOW_MBC_DASHBOARD),
  },
  SBL_6160_ENABLE_MBC_CLASS: {
    description: 'Shows button to create classes in MBC dashboard',
    defaultValue: boolValue(process.env.SBL_6160_ENABLE_MBC_CLASS),
  },
  SBL_6509_HIDE_APPROVED_QE_PERMS: {
    description:
      'Hides the mark as approved checkbox if user does not have permissions',
    defaultValue: boolValue(process.env.SBL_6509_HIDE_APPROVED_QE_PERMS),
  },
  SBL_6477_PERMISSION_VIEWER: {
    description: 'Enables permission viewer',
    defaultValue: boolValue(process.env.SBL_6477_PERMISSION_VIEWER),
  },
  SBL_4400_DOWNLOAD_MBC_FILE: {
    description: 'Show or hide Download File from the MBC Search page',
    defaultValue: boolValue(process.env.SBL_4400_DOWNLOAD_MBC_FILE),
  },
  SBL_6772_SHOW_MEMBER_ID_COLUMN: {
    description: 'Show or hide Member ID column from the MBC Search page',
    defaultValue: boolValue(process.env.SBL_6772_SHOW_MEMBER_ID_COLUMN),
  },
  SBL_6161_MBC_CLASS_ENTRY: {
    description: 'Shows screen for entering MB requirements by MBC class',
    defaultValue: boolValue(process.env.SBL_6161_MBC_CLASS_ENTRY),
  },
  SBL_6604_ADVENTURES_RTK: {
    description: 'Enables the use RTK for adventures requirements page',
    defaultValue: boolValue(process.env.SBL_6604_ADVENTURES_RTK),
  },
  SBL_4163_GENERATE_CLASS_WORKSHEET: {
    description: 'Enables generating class worksheet from MBC',
    defaultValue: boolValue(process.env.SBL_4163_GENERATE_CLASS_WORKSHEET),
  },
  SBL_5391_ENABLE_ATTENDANCE_EVENT_ACTIVITIES: {
    description:
      'Enables the use of attended or RSVPd users to auto fill activities in events',
    defaultValue: boolValue(
      process.env.SBL_5391_ENABLE_ATTENDANCE_EVENT_ACTIVITIES,
    ),
  },
  SBL_6680_EAGLE_CIS_VERSION_SWITCH: {
    description:
      'Enables Eagle CIS version switching and date override for Eagle v2022',
    defaultValue: boolValue(process.env.SBL_6680_EAGLE_CIS_VERSION_SWITCH),
  },
  SBL_6145_LEADER_SIGN_BLUE_CARD: {
    description:
      'Allow leaders to sign the blue card either as themselves or on behalf of another leader.',
    defaultValue: boolValue(process.env.SBL_6145_LEADER_SIGN_BLUE_CARD),
  },
  SBL_6753_ENABLE_BCC_MESSAGING: {
    description: 'Enable BCC in messaging',
    defaultValue: boolValue(process.env.SBL_6753_ENABLE_BCC_MESSAGING),
  },
  SBL_4447_ENABLE_ATTACHMENT_MESSAGING: {
    description: 'Enable attachment in messaging',
    defaultValue: boolValue(process.env.SBL_4447_ENABLE_ATTACHMENT_MESSAGING),
  },
  SBL_6750_ROSTER_LITE: {
    description: 'Lite roster view for limited-permission positions',
    defaultValue: boolValue(process.env.SBL_6750_ROSTER_LITE),
  },
  SBL_6888_ROSTER_V2: {
    description: 'New roster page built on RTK / RTK Query (Roster V2)',
    defaultValue: boolValue(process.env.SBL_6888_ROSTER_V2),
  },
  SBL_6587_MERIT_BADGE_COUNSELORS_READING: {
    description: 'Enable getting Merit Badge Counselors in Youth Profile',
    defaultValue: boolValue(
      process.env.SBL_6587_MERIT_BADGE_COUNSELORS_READING,
    ),
  },
  SBL_6815_HIDE_LOGIN_V2: {
    description: 'Hide login v2 that looks like the scoutbook one',
    defaultValue: boolValue(process.env.SBL_6815_HIDE_LOGIN_V2),
  },
  SBL_6779_OPT_OUT_OVERRIDE_MESSAGING: {
    description: 'Enable Opt Out Override when adult has youth in Messaging',
    defaultValue: boolValue(process.env.SBL_6779_OPT_OUT_OVERRIDE_MESSAGING),
  },
  SBL_6790_ENABLE_NO_MB_FILTER: {
    description: 'Enables the filtering of No MB MBC and BOTH',
    defaultValue: boolValue(process.env.SBL_6790_ENABLE_NO_MB_FILTER),
  },
  SBL_6852_ENABLE_ADV_RESET: {
    description: 'Enable button to reset advancements requirements',
    defaultValue: boolValue(process.env.SBL_6852_ENABLE_ADV_RESET),
  },
  SBL_6061_DISABLE_RECAPTCHA: {
    description: 'Disable google recaptcha for logging in.',
    defaultValue: boolValue(process.env.SBL_6061_DISABLE_RECAPTCHA),
  },
  SBL_6742_ATTENDANCE_USER_ORG_LIMIT: {
    description: 'Disable event attendance for orgs not belonging to the user',
    defaultValue: boolValue(process.env.SBL_6742_ATTENDANCE_USER_ORG_LIMIT),
  },
  SBL_6789_SORT_WITH_API: {
    description: 'Enable the sorting via API',
    defaultValue: boolValue(process.env.SBL_6789_SORT_WITH_API),
  },
  SBL_6856_LAX_MESSAGING_CHARACTERS: {
    description: 'Enable the use of [] in messaging subjects',
    defaultValue: boolValue(process.env.SBL_6856_LAX_MESSAGING_CHARACTERS),
  },
  SBL_6835_FILTER_VENTURE_PATROL_LEADER: {
    description: 'Filter Venture Patrol Leader from bulk and individual entry',
    defaultValue: boolValue(process.env.SBL_6835_FILTER_VENTURE_PATROL_LEADER),
  },
  SBL_3233_DYNAMIC_BANNER: {
    description: 'Enable dynamic banner feature',
    defaultValue: boolValue(process.env.SBL_3233_DYNAMIC_BANNER),
  },
  SBL_6904_ENABLE_AKELA_SBORGID: {
    description:
      'Enable the use of akela profile when loging in to get the unit id from sborganizationId',
    defaultValue: boolValue(process.env.SBL_6904_ENABLE_AKELA_SBORGID),
  },
  SBL_6889_USE_OLD_RSVP_REMINDERS: {
    description: 'Use old RSVP drop down for RSVP reminders',
    defaultValue: boolValue(process.env.SBL_6889_USE_OLD_RSVP_REMINDERS),
  },
  SBL_6921_ADV_QE_V2: {
    description: 'Use v2 of advancement quick entry',
    defaultValue: boolValue(process.env.SBL_6921_ADV_QE_V2),
  },
  SBL_6895_UNIT_ROSTER: {
    description: 'Unit roster + youth advancement profile for youth/parents',
    defaultValue: boolValue(process.env.SBL_6895_UNIT_ROSTER),
  },
  SBL_6727_MBC_BULK_BLUE_CARD: {
    description: 'Enable bulk blue card download for MBC',
    defaultValue: boolValue(process.env.SBL_6727_MBC_BULK_BLUE_CARD),
  },
  SBL_6855_ONLINE_DEPOSITS: {
    description: 'Enable online deposits in payment logs',
    defaultValue: boolValue(process.env.SBL_6855_ONLINE_DEPOSITS),
  },
  SBL_6922_ENABLE_SCOUT_LIFE_AD: {
    description: 'Enable Scout Life Ad on Calendar Page',
    defaultValue: boolValue(process.env.SBL_6922_ENABLE_SCOUT_LIFE_AD),
  },
  SBL_6926_NEW_SESSION_LOGIC: {
    description: 'Change social session api',
    defaultValue: boolValue(process.env.SBL_6926_NEW_SESSION_LOGIC),
  },
  SBL_6966_USE_ORGADULT_PERMMANAGER: {
    description:
      'Enable the use of orgAdult API instead of roster in perm manager',
    defaultValue: boolValue(process.env.SBL_6966_USE_ORGADULT_PERMMANAGER),
  },
  SBL_6013_IMPORT_COUNCIL_FILE: {
    description: 'Enable import council file for council admins',
    defaultValue: boolValue(process.env.SBL_6013_IMPORT_COUNCIL_FILE),
  },
  SBL_6013_IMPORT_COUNCIL_FILE_UNITS: {
    description:
      'Comma separated org guids that get the council file import while SBL_6013_IMPORT_COUNCIL_FILE is off',
    defaultValue: process.env.SBL_6013_IMPORT_COUNCIL_FILE_UNITS,
    type: 'string' as const,
  },
  SBPD_218_DISABLE_SUB_EVENT_SCOPE: {
    description: 'Disable the use of subunit scope when cloning events',
    defaultValue: process.env.SBPD_218_DISABLE_SUB_EVENT_SCOPE,
  },
  SBPD_219_EVENT_FALLBACK_ORGGUID: {
    description:
      'QA only: Enables fallback to find units with perms in events using orgGuid when there is no unitId',
    defaultValue: process.env.SBPD_219_EVENT_FALLBACK_ORGGUID,
  },
  SBPD_222_REMOVE_PARTIAL_SB_POSITIONS: {
    description:
      'Remove large number of SB positions that comes in roletypes and permission manager',
    defaultValue: boolValue(process.env.SBPD_222_REMOVE_PARTIAL_SB_POSITIONS),
  },
  SBL_6090_ENABLE_FROM_MESSAGING_FIELD: {
    description: 'Enable From input field in Messaging',
    defaultValue: boolValue(process.env.SBL_6090_ENABLE_FROM_MESSAGING_FIELD),
  },
  SBL_6944_ENABLE_ADDITIONAL_ADVANCEMENTS_CARD_CATEGORIES: {
    description:
      'Enable additional (All, Approved/Completed) summary boxes on Advancement Cards',
    defaultValue: boolValue(
      process.env.SBL_6944_ENABLE_ADDITIONAL_ADVANCEMENTS_CARD_CATEGORIES,
    ),
  },
  SBL_7006_RECAPTCHA_TOKEN: {
    description: 'Send the google recaptcha token to the authenticate endpoint',
    defaultValue: boolValue(process.env.SBL_7006_RECAPTCHA_TOKEN),
  },
  SBL_6782_PAYMENT_LOG_NOTES: {
    description: 'Show the notes card on the person Payment Logs page',
    defaultValue: boolValue(process.env.SBL_6782_PAYMENT_LOG_NOTES),
  },
  SBL_7000_SKIP_CAMP_FILE_SIZE_LIMIT: {
    description:
      'Skip the 300 KB file size limit on the camp CSV advancement import',
    defaultValue: boolValue(process.env.SBL_7000_SKIP_CAMP_FILE_SIZE_LIMIT),
  },
  SBL_7035_NEW_PARENT_RESPONSE: {
    description:
      'Enable transform of new response to backward compatible data-structure.',
    defaultValue: boolValue(process.env.SBL_7035_NEW_PARENT_RESPONSE),
  },
  SBL_7033_MBC_CLASS_RECORD_PROGRESS: {
    description:
      'Shows Record Progress on MBC class headers to open Bulk Entry with the selected scouts',
    defaultValue: boolValue(process.env.SBL_7033_MBC_CLASS_RECORD_PROGRESS),
  },
  SBL_6977_ROSTER_V2_SUB_UNITS: {
    description: 'Manage dens and patrols (sub-units) from the Roster V2 page',
    defaultValue: boolValue(process.env.SBL_6977_ROSTER_V2_SUB_UNITS),
  },
  SBL_6978_RANK_QE_AKELA: {
    description: 'Rank quick entry lists youth from the Akela roster',
    defaultValue: boolValue(process.env.SBL_6978_RANK_QE_AKELA),
  },
};

// Env vars hidden from feature flag manager
export const OMIT_REGEX = [/ADOBE.*/, /WEPAY.*/, /_DEV$/, /API.*/, /NODE.*/];
export const OMIT_SET = new Set([
  'ENABLE_MSW',
  'APP_VERSION',
  'COMMITHASH',
  'ENV',
  'DEV_WARNINGS',
  'GOOGLE_SIGN_IN_CLIENT_ID',
  'GOOGLE_RECAPTCHA_INVI_SITE_KEY',
  'DEV_MASQUERADE_LOGIN',
  'DEV_MASQUERADE_USERNAME',
  'DEV_MASQUERADE_PASSWORD',
]);

// A random string to not give clue
export const LSTORAGE_KEY = 'ov2_VrK3';
